﻿import React, { useContext, useState, useMemo } from 'react';
import { Helmet } from "react-helmet";
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';

import { H2 } from '@Elements/Fonts';
import Page_Header from '@Elements/Page_Header';
import Reminders_Table from '@Elements/Reminders_Table';
import Add_Reminder_Popup from '@Modules/Popups/Add_Reminder_Popup';

import {
    Reminder,
    Reminders_Sorted_Data
} from '@Util/Types';

export default function Reminderspage(): JSX.Element {
    const [t] = useTranslation();
    const { reminders }: context_type = useContext(Context);
    const [add_reminder_popup_open, set_add_reminder_popup_open] = useState<boolean>(false);

    const sorted_reminder_data: Reminders_Sorted_Data = useMemo(() => {
        let personal_reminders: Reminder[] = reminders.filter(reminder => reminder.type === "Personal");
        let global_reminders: Reminder[] = reminders.filter(reminder => reminder.type === "Global");

        return {
            personal_reminders: personal_reminders,
            global_reminders: global_reminders
        }
    }, [reminders]);

    return (
        <>
            <Helmet>
                <title>{`${t('Navigation.Reminders')} - InTime`}</title>
            </Helmet>
            <Page_Header
                headline={t('Navigation.Reminders')}
                button_aria_name={t('Text.AddReminder')}
                button_action={() => set_add_reminder_popup_open(true)}
            />
            {
                sorted_reminder_data.personal_reminders?.length > 0 &&
                <>
                    <H2>{t('Text.PersonalReminders')}</H2>
                    <Reminders_Table data={sorted_reminder_data?.personal_reminders} />
                </>
            }
            {
                sorted_reminder_data.global_reminders?.length > 0 &&
                <>
                    <H2>{t('Text.GlobalReminders')}</H2>
                    <Reminders_Table data={sorted_reminder_data?.global_reminders} />
                </>
            }
            <Add_Reminder_Popup
                open={add_reminder_popup_open}
                set_open={set_add_reminder_popup_open}
            />
        </>
    );
}